module.exports = __webpack_public_path__ + "media/images/info-red-424f0f211d623b7945754799acdaad69.svg";